import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class MdmWorkfilesConfigService {

  defaultTimeout = 600000;

  constructor(private http: HttpClient) { }

      // Get the plate details for workfile config
    getPlateDetailsByProcessStep(request: any): Observable<any> {
      let url = environment.BB_MDMSERVICE_URL + 'mdm/workfile/getPlateDetails';
      return this.http.put<any>(url, request).pipe(timeout(environment.defaultTimeout));
  }
}
